export enum RightStatus {
  ACTIVE = "Active",
  RELEASED = "Released",
  EXPIRED = "Expired",
}

export enum RightType {
  TWO_D_ARTWORK = "2D Artwork",
  CELEBRITY_GUARANTEE = "Celebrity Guarantee",
  CHARACTER_LICENSE = "Character License",
  CLEARANCE_LIMITATION = "Clearance Limitation",
  CUSTOMER_PROVIDED_MATERIALS = "Customer Provided Materials",
  DORMANCY_FEES = "Dormancy Fees",
  FILM_FOOTAGE_LICENSE = "Film Footage License",
  FONT_LICENSE = "Font License",
  ILLUSTRATOR = "Illustrator",
  INFLUENCER = "Influencer",
  MUSIC_DEMO_FEE = "Music Demo Fee",
  MUSIC_MASTER_LICENSE = "Music Master License",
  MUSIC_PUBLISHING_LICENSE = "Music Publishing License",
  MUSIC_MASTER_AND_PUBLISHING_LICENSE = "Music Master and Publishing License",
  NON_UNION_BACKGROUND_EXTRA = "Non-Union Background Extra",
  NON_UNION_CHARACTER_VOICE = "Non-Union Character Voice",
  NON_UNION_DRIVER = "Non-Union Driver",
  NON_UNION_FEATURED_EXTRA = "Non-Union Featured Extra",
  NON_UNION_INFLUENCER = "Non-Union Influencer",
  NON_UNION_ON_CAMERA_PRINCIPAL = "Non-Union On-Camera Principal",
  NON_UNION_OTHER = "Non-Union Other",
  NON_UNION_VOICEOVER = "Non-Union Voiceover",
  NON_UNION_AGREEMENT = "Non-Union Agreement",
  ORIGINAL_MUSIC_LICENSE = "Original Music License",
  ORIGINAL_MUSIC_NON_AFM = "Original Music (Non-AFM)",
  OTHER = "Other",
  PHOTOGRAPHER = "Photographer",
  PRINCIPAL_MODEL = "Principal Model",
  PROMOTIONAL_LICENSE = "Promotional License",
  RIGHT_OF_PUBLICITY = "Right of Publicity",
  SPORTING_EVENT_FOOTAGE_LICENSE = "Sporting Event Footage License",
  STOCK_ARTWORK_2D = "Stock Artwork (2D)",
  STOCK_FILM_FOOTAGE = "Stock Film Footage",
  STOCK_MUSIC = "Stock Music",
  STOCK_PHOTO = "Stock Photo",
  TERM_GUARANTEE = "Term Guarantee",
  UNION_TALENT = "Union Talent",
}
